import { c as _c } from "react/compiler-runtime";
import { Check } from "@mui/icons-material";
import React from "react";
import styled from "styled-components";
import { Text, TextColor, TextSize, TextVariant, TextWeight } from "../../../components";
export const StepHeader = t0 => {
  const $ = _c(19);
  const {
    stepNumber,
    title,
    isActive,
    isCompleted,
    onEdit
  } = t0;
  let t1;
  if ($[0] !== isCompleted || $[1] !== stepNumber) {
    t1 = isCompleted ? <Check className="text-white !w-4 !h-4" /> : <Text text={stepNumber.toString()} fontSize={TextSize.S} weight={TextWeight.SEMIBOLD} />;
    $[0] = isCompleted;
    $[1] = stepNumber;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isActive || $[4] !== isCompleted || $[5] !== t1) {
    t2 = <NumberCircle $isActive={isActive} $isCompleted={isCompleted}>{t1}</NumberCircle>;
    $[3] = isActive;
    $[4] = isCompleted;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = !isActive ? TextColor.GRAYSCALE_400 : undefined;
  let t4;
  if ($[7] !== t3 || $[8] !== title) {
    t4 = <Text text={title} variant={TextVariant.H6} weight={TextWeight.SEMIBOLD} color={t3} />;
    $[7] = t3;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div className="flex items-center gap-4">{t2}{t4}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== isCompleted || $[14] !== onEdit) {
    t6 = isCompleted && onEdit && <Text text={"Zmie\u0144"} onClick={onEdit} className="cursor-pointer" fontSize={TextSize.S} />;
    $[13] = isCompleted;
    $[14] = onEdit;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className="flex justify-between items-center mb-6">{t5}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export const NumberCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #000;
  background-color: ${({
  $isCompleted
}) => $isCompleted ? "#000" : "transparent"};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.3s ease;
`;
export const StepSection = styled.div`
  margin-bottom: 2rem;
  opacity: ${({
  $isActive
}) => $isActive ? 1 : 0.5};
  transition: opacity 0.3s ease;
`;